/**
 * @readonly
 * @enum {string}
 */
export enum USER_GUIDE_ADMIN_PANEL_URL {
  PEARL_2 = 'https://www.epiphan.com/userguides/pearl/Content/UserGuides/Streaming/setup/connectToAdmin.htm',
  PEARL_MINI = 'https://www.epiphan.com/userguides/pearl-mini/Content/UserGuides/Streaming/setup/connectToAdmin.htm',
}
